<template>
  <div :class="rootClassName">
    <span v-if="$slots.icon" class="mr-4">
      <slot name="icon" />
    </span>

    <div class="flex-grow mr-4">
      <slot />

      <div v-if="$slots.actions" class="mt-4">
        <slot name="actions" />
      </div>
    </div>

    <IconButton @click="handleClose" class="-mr-1 -mt-1">
      <Icon name="times" />
    </IconButton>
  </div>
</template>

<script>
import IconButton from '@converdy/atoms/IconButton';
import Icon from '@converdy/atoms/Icon';

export default {
  name: 'ToastsHelper',

  components: {
    Icon,
    IconButton,
  },

  props: {
    autoHideDuration: {
      type: Number,
      default: 3000,
    },

    type: {
      type: String,
      default: 'info',
      validator: (v) => ['success', 'warning', 'info', 'error'].includes(v),
    },
  },

  data: () => ({autoHideTimeoutId: null}),

  mounted() {
    if (this.autoHideDuration) {
      this.autoHideTimeoutId = setTimeout(
        this.handleClose.bind(this),
        this.autoHideDuration,
      );
    }
  },

  methods: {
    handleClose() {
      this.$emit('close');
      this.clearAutoHideTimeoutId();
    },

    clearAutoHideTimeoutId() {
      if (this.autoHideTimeoutId) {
        clearTimeout(this.autoHideTimeoutId);
      }
    },
  },

  computed: {
    rootClassName() {
      return [this.$style.root, this.$style[this.type]];
    },
  },
};
</script>

<style module>
.root {
  display: flex;
  align-items: center;
  position: relative;
  @apply 
    bg-white
    mb-2
    p-4
    rounded
    shadow-md
    border-l
}

.success {
  @apply border-success;
}

.warning {
  @apply border-warning;
}

.error {
  @apply border-danger;
}
</style>
